var render = function render(){var _vm=this,_c=_vm._self._c;return _c('form-row',{attrs:{"title":"Clear to Close?"}},[_c('div',{staticClass:"flex flex-1 items-center"},[_c('input-radio-boolean',{attrs:{"name":"clear_to_close","value":_vm.mortgage.clear_to_close,"true":"Yes","false":"No","read_only":_vm.read_only}})],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }